"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ShortcodeEdit;

var _element = require("@wordpress/element");

var _i18n = require("@wordpress/i18n");

var _blockEditor = require("@wordpress/block-editor");

var _compose = require("@wordpress/compose");

var _icons = require("@wordpress/icons");

/**
 * WordPress dependencies
 */
function ShortcodeEdit(_ref) {
  let {
    attributes,
    setAttributes
  } = _ref;
  const instanceId = (0, _compose.useInstanceId)(ShortcodeEdit);
  const inputId = `blocks-shortcode-input-${instanceId}`;
  return (0, _element.createElement)("div", (0, _blockEditor.useBlockProps)({
    className: 'components-placeholder'
  }), (0, _element.createElement)("label", {
    htmlFor: inputId,
    className: "components-placeholder__label"
  }, (0, _element.createElement)(_icons.Icon, {
    icon: _icons.shortcode
  }), (0, _i18n.__)('Shortcode')), (0, _element.createElement)(_blockEditor.PlainText, {
    className: "blocks-shortcode__textarea",
    id: inputId,
    value: attributes.text,
    "aria-label": (0, _i18n.__)('Shortcode text'),
    placeholder: (0, _i18n.__)('Write shortcode here…'),
    onChange: text => setAttributes({
      text
    })
  }));
}
//# sourceMappingURL=edit.js.map